<div *ngIf="showScheduledBanner" class="subscription-banner subscription-banner--scheduled" role="status">
  <i class="material-icons subscription-banner__icon" aria-hidden="true">warning</i>
  <div class="subscription-banner__text">
    <strong class="subscription-banner__title">{{ messages.scheduledTitle }}</strong>
    <span>
      Your subscription will be auto-renewed {{ scheduledLead }} {{ subscription.expiryDate | date: dateFormat : 'UTC' }}.
      Your saved card <ng-container *ngIf="savedCardText">{{ savedCardText }} </ng-container>will be charged.
    </span>
  </div>
  <button *ngIf="showActionButton" type="button" class="btn rounded_btn small_btn px-3 subscription-banner__action" (click)="viewSubscription.emit()">
    View Subscription
  </button>
</div>

<div
  *ngIf="showBanner"
  class="subscription-banner"
  [ngClass]="'subscription-banner--' + subscription.status"
  role="alert"
>
  <i class="material-icons subscription-banner__icon" aria-hidden="true">warning</i>
  <div class="subscription-banner__text">
    <strong class="subscription-banner__title">{{ statusLabel }}</strong>
    <span>{{ bannerMessage }}</span>
  </div>
  <button type="button" class="btn rounded_btn green_btn small_btn px-3 subscription-banner__action" (click)="onRenew()">
    Renew Subscription
  </button>
</div>


<div *ngIf="showCard" class="subscription-card" [ngClass]="'subscription-card--' + subscription.status">
  <div class="subscription-card__header">
    <div  class="subscription-card__icon">

      <svg class="subscription-card__icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff"><path d="M200-160v-80h560v80H200Zm0-140-51-321q-2 0-4.5.5t-4.5.5q-25 0-42.5-17.5T80-680q0-25 17.5-42.5T140-740q25 0 42.5 17.5T200-680q0 7-1.5 13t-3.5 11l125 56 125-171q-11-8-18-21t-7-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820q0 15-7 28t-18 21l125 171 125-56q-2-5-3.5-11t-1.5-13q0-25 17.5-42.5T820-740q25 0 42.5 17.5T880-680q0 25-17.5 42.5T820-620q-2 0-4.5-.5t-4.5-.5l-51 321H200Z"/></svg>
    </div>
    <span class="subscription-card__title">Subscription Status</span>
    <span class="subscription-card__status" [ngClass]="'subscription-card__status--' + subscription.status">{{ cardStatusLabel }}</span>
  </div>
  <p class="subscription-card__plan" *ngIf="planLabel">{{ planLabel }}</p>
  <p class="subscription-card__expiry" *ngIf="subscription.expiryDate || showDaysLeft">
    <ng-container *ngIf="subscription.expiryDate">{{ expiryPrefix }} {{ subscription.expiryDate | date: dateFormat : 'UTC' }}</ng-container>
    <span class="subscription-card__days" *ngIf="showDaysLeft">({{ daysRemaining }} {{ daysRemaining === 1 ? 'Day' : 'Days' }} Left)</span>
  </p>
  <div class="subscription-card__autorenew" *ngIf="showAutoRenew">
    <ng-container *ngTemplateOutlet="autoRenewBlock"></ng-container>
  </div>
</div>

<div *ngIf="showAutoRenewPanel" class="subscription-autorenew-panel">
  <ng-container *ngTemplateOutlet="autoRenewBlock"></ng-container>
</div>

<ng-template #autoRenewBlock>

  <div class="subscription-card__autorenew-row">
    <div class="subscription-card__autorenew-text">
      <span class="subscription-card__autorenew-label" [id]="autoRenewLabelId">Auto-Renewal</span>
      <span class="subscription-card__autorenew-state">{{ autoRenewStateText }}</span>
    </div>
    <mat-slide-toggle
      *ngIf="canChangeAutoRenew"
      class="subscription-card__autorenew-toggle"
      [checked]="subscription.autoRenew"
      [disabled]="autoRenewToggleDisabled"
      [aria-labelledby]="autoRenewLabelId"
      (change)="onAutoRenewChange($event)"
    ></mat-slide-toggle>
  </div>
  <p class="subscription-card__autorenew-info" *ngIf="showAutoRenewCharge">
    <i class="material-icons subscription-card__autorenew-info-icon" aria-hidden="true">info</i>
    <span>Your saved payment method will be charged on {{ subscription.expiryDate | date: dateFormat : 'UTC' }}.</span>
  </p>
  <p class="subscription-card__autorenew-reason" *ngIf="autoRenewReason">{{ autoRenewReason }}</p>
  <span class="subscription-card__autorenew-live" role="status" aria-live="polite">{{ autoRenewAnnouncement }}</span>
</ng-template>
